import { useEffect, useState } from "react";
import { UsersModel } from "../../../api";
import { fetchClioUsers } from "./clioSelectApi";

export function useClioUsers(removeDisabled = false, enabled = true) {
  const [users, setUsers] = useState<UsersModel[]>([]);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setUsers([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    fetchClioUsers(removeDisabled).then((next) => {
      if (!cancelled) {
        setUsers(next);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [removeDisabled, enabled]);

  return { users, loading };
}
